import axiosInstance from "../../utils/axiosInstance";

const getBlog = async (id) => {
  const response = await axiosInstance.get(`/blogs/${id}`);
  return response.data;
};

export default getBlog;
